module.exports = __webpack_public_path__ + "media/images/emblems/Meyriez-coat_of_arms-be478c79b23f658bb66d7898d5274252.svg";